<template lang="pug">
  .modal(
    role="dialog"
    tabindex="-1" 
    style="display:block;" 
    aria-hidden="true"
  )
    .modal-dialog.modal-dialog-scrollable.modal-dialog-centered(role="document")
      .modal-content
        .modal-header
          SectionTitle(:sectionText="sectionText")
        .modal-body
          .popup-item.popup-item--wrapColumn
            textarea(
              :class="alert.content.textarea" 
              placeholder="請輸入話題內容"
              v-model="params.content"
              :maxlength="contentMaximum"
              @input="checkActive"
            )
            .popup-alertText(v-if="alert.content.alertText")
              | 已達字數上限
            div(:class="alert.content.counter")
              span.popup-remainingCounter {{ params.content.length }}
              span.popup-limitCounter {{ contentMaximum }}
          .popup-item.popup-item--wrapColumn
            span.popup-text 分類話題
            Dropdown(
              id="option"
              placeholder="請選擇"
              :selectText='categoryName'
              :infos="items"
              optionClass="popup-option"
              innerTextClass="popup-option-innerText"
              @selectDropdown="selectDropdown"
              :isEduChild="true"
            )
        .modal-footer
          PopupButtonsOnBottom(
            :isActive="isActive"
            :isScrollablePopup='true'
            :isSingleButton='false'
            @send="send"
            @cancel="closePopup"
          )
</template>

<script>
import StaticData from '@/assets/data.json';
import SectionTitle from '@/components/modules/section_title/section_title.vue';
import PopupButtonsOnBottom from '@/components/popup/popup-buttons-on-bottom.vue';
import Dropdown from '@/components/modules/dropdown.vue';
import { lockBody, unlockBody, checkPopupAlert } from '@/plugins/tool.js';
import { createArticle } from '@/utils/api';

export default {
  components: {
    SectionTitle,
    Dropdown,
    PopupButtonsOnBottom
  },
  props: {
    sectionText: String
  },
  computed: {
    isActive() {
      return (
        !!this.params.content &&
        this.params.content.length >= this.contentMinimum &&
        this.params.content.length <= this.contentMaximum &&
        !!this.params.categoryId
      );
    },
    items() {
      const categories =
        StaticData[this.$store.state.lang].partnerMain.categories;
      return categories.filter(category => category.id !== '0');
    },
    apiToken() {
      return localStorage.getItem(this.$store.state.storageKeys.token);
    }
  },
  data() {
    return {
      isProcessing: false,
      params: {
        content: '',
        categoryId: ''
      },
      categoryName: '',
      row: 15,
      contentMinimum: 10,
      contentMaximum: 1000,
      alert: {
        content: {
          textarea: 'popup-textarea',
          counter: 'popup-counter',
          alertText: false
        }
      }
    };
  },
  mounted() {
    lockBody();
  },
  methods: {
    checkActive() {
      this.alert.content = checkPopupAlert(
        this.params.content.length > this.contentLimit,
        this.alert.content
      );
    },
    closePopup() {
      unlockBody();
      this.$emit('closePopup');
    },
    async send() {
      if (!this.isActive || this.isProcessing) return;
      this.isProcessing = true;
      createArticle(this.apiToken, this.params)
        .then(() => {
          this.isProcessing = false;
          this.closePopup();
          this.$emit('onSuccess');
          window.location.reload();
        })
        .catch(() => {
          this.isProcessing = false;
          this.closePopup();
          this.$emit('onError');
        });
    },
    selectDropdown(event) {
      this.params.categoryId = event.id;
      this.categoryName = event.name;
      this.checkActive();
    }
  }
};
</script>
<style scoped src="../../assets/koromo_min.css"></style>
<style scoped src="./popupAddArticle.vue.css"></style>
